import React, { useEffect } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import { useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import HeaderOthers from "../components/HeaderOthers";

const useStyle = makeStyles((theme) => ({
  root: {
    margin: "60px 0px",
  },
  title: {
    fontSize: "1.5rem !important",
    fontWeight: "500 !important",
    marginBottom: "20px !important",
  },
  content: {
    fontSize: "1rem",
    marginBottom: "20px !important",
  },
  subtitle: {
    fontSize: "1rem",
    marginBottom: "20px !important",
    fontWeight: "500 !important",
  },

  icon: {
    marginRight: 10,
    position: "relative",
    top: 5,
  },
  select: {
    marginBottom: 30,
  },
  footer: {
    marginTop: "-80px",
  },
}));

const Faq = () => {
  const classes = useStyle();

  useEffect(() => {
    window.scrollTo(0, -1);
  }, []);

  const location = useLocation();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <HeaderOthers title="Frequently asked questions" customLink="FAQs" />
      <div className={classes.root}>
        <Container maxWidth="lg" style={{ marginBottom: "110px" }}>
          <Grid container spacing={2}>
            <Grid item md={12} style={{ width: "100%" }}>
              <h4>General FAQs about ST Pay</h4>
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography>About ST Pay</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    ST Pay is an e-wallet application of Green and Red
                    Technologies Limited available in iOS and Android.The smart
                    phone/tab devices and web versions are products of G&R
                    licensed as a Payment Service Provider (PSP) by Bangladesh
                    Bank.The purpose of the app is to keep the society cashless,
                    make life convenient and to implement a Lifestyle Service
                    which is seamless and secure in the Digital world.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content2"
                  id="panel1bh-header2"
                >
                  <Typography>
                    What are the services provided by ST Pay?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ul>
                    <li>
                      <Typography variant="body2">Send Money</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Receive Money</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Add money</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Transfer to Bank</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Request money</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Mobile Recharge</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Bill Payment</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Scan and pay</Typography>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content3"
                  id="panel1bh-header3"
                >
                  <Typography>How can a person download ST Pay?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">For Android user:</Typography>
                  <ol>
                    <li>
                      <Typography variant="body2">
                        Download Android personal from Google Playstore
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Download Android Merchant from Google Playstore
                      </Typography>
                    </li>
                  </ol>
                  <Typography variant="body2">For iOS USER:</Typography>
                  <ol>
                    <li>
                      <Typography variant="body2">
                        Download iOS personal from Apple App Store
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Download iOS Merchant from Apple App Store
                      </Typography>
                    </li>
                  </ol>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel4"}
                onChange={handleChange("panel4")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content4"
                  id="panel1bh-header4"
                >
                  <Typography>
                    How many types of accounts are available in ST Pay?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    There are two types of account in ST Pay which are
                  </Typography>
                  <ol>
                    <li>
                      <Typography variant="body2">Personal Account</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Merchant Account</Typography>
                    </li>
                  </ol>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel5"}
                onChange={handleChange("panel5")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content5"
                  id="panel1bh-header5"
                >
                  <Typography>
                    How to create a ST Pay Personal Account?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                      <h4>Open Your ST Pay Account Easily</h4>
                      <p>
                        Getting started with ST Pay is quick and convenient! You can now open a new ST Pay account without hassle, right from your mobile phone anytime, anywhere. Account registration is currently supported on Airtel, Banglalink, Teletalk, Grameenphone, and Robi connections.
                      </p>

                      <h4>What You’ll Need:</h4>
                      <ul>
                        <li>A mobile phone</li>
                        <li>Your original National ID card</li>
                      </ul>

                      <h4>Steps to Register via the ST Pay App:</h4>
                      <ol>
                        <li>Open the ST Pay app and tap “Login/Register”.</li>
                        <li>Enter your mobile number.</li>
                        <li>Verify your number using the code sent via SMS.</li>
                        <li>Create a 4-digit PIN and confirm it.</li>
                        <li>Accept the terms and conditions to continue.</li>
                        <li>Upload clear photos of the front and back of your National ID card.</li>
                        <li>Review the auto-filled information and confirm.</li>
                        <li>Capture a selfie using your phone’s camera.</li>
                        <li>Submit all details for verification.</li>
                        <li>Wait for the confirmation SMS (verification may take up to 72 hours).</li>
                        <li>Once approved, log in to the ST Pay app and start using your account.</li>
                      </ol>

                      <h4 style={{marginTop: "30px"}}>Always keep your PIN confidential and never share it with anyone.</h4>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel6"}
                onChange={handleChange("panel6")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content6"
                  id="panel1bh-header6"
                >
                  <Typography>
                    How to create a ST Pay Merchant Account?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Kindly contact support to create a ST Pay Merchant Account
                    by sending e-mail to <a href="mailto:support@stpay.net" style={{ color: "#3d96ff" }}>support@stpay.net</a>,
                    or call <a href="tel:+8809617343434" style={{ color: "#3d96ff" }}>+8809617343434</a>.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel7"}
                onChange={handleChange("panel7")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content7"
                  id="panel1bh-header7"
                >
                  <Typography>How to log into ST Pay?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    You can simply log into your ST Pay by putting the password
                    you will set.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel8"}
                onChange={handleChange("panel8")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content8"
                  id="panel1bh-header8"
                >
                  <Typography>Who is eligible for ST Pay services?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Anybody with a valid National Identity Card (NID), Phone Number And Bank Account.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <h4>Services that are provided by ST Pay</h4>

              <Accordion
                expanded={expanded === "panel9"}
                onChange={handleChange("panel9")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content9"
                  id="panel1bh-header9"
                >
                  <Typography>
                    How to Top-Up/Recharge Mobile Balance with my ST Pay wallet?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ul>
                    <li>
                      <Typography variant="body2">
                        Tap on ‘Mobile Recharge’ from ST Pay main interface
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Type in phone number or select desired contact from
                        phone log
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Choose Current Operator
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Select Prepaid/Postpaid phone plan
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Insert recharge amount
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Enter ST Pay PIN</Typography>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>

              {/* Add Money Section */}
              <Accordion
                expanded={expanded === "panel10"}
                onChange={handleChange("panel10")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>
                    How do I add money to my ST Pay account?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <ul>
                      <li>
                        <Typography variant="body2">Click add money</Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Click card to ST Pay
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Write the amount you want to add to ST Pay
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Then there will be a page named payment Details
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">Click card type</Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Put the card number and other details of the chosen
                          card and click pay
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Then you can tap for balance to check if the money has
                          been added
                        </Typography>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Send Money */}
              <Accordion
                expanded={expanded === "panel11"}
                onChange={handleChange("panel11")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content11"
                  id="panel1bh-header11"
                >
                  <Typography>How do you send money from ST Pay?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <ul>
                      <li>
                        <Typography variant="body2">
                          Click send money
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Put the phone number you want to send money to.
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          And write the amount you want to send to the number
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Insert ST Pay PIN
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Then click on next
                        </Typography>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Bank beneficiary */}
              <Accordion
                expanded={expanded === "panelBankBeneficiary"}
                onChange={handleChange("panelBankBeneficiary")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>
                    Why do I need to add a bank beneficiary?
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography variant="body2">
                    To ensure smooth transactions and increase your monthly
                    transaction limit. Without adding a bank account your
                    monthly transaction limit is capped at BDT 10,000.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Bank beneficiary - HOW */}
              <Accordion
                expanded={expanded === "panelBankBeneficiary-how"}
                onChange={handleChange("panelBankBeneficiary-how")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>How do I add a bank beneficiary?</Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography variant="body2">
                    Follow these steps to add your bank account:
                    <ul>
                      <li>
                        <Typography variant="body2">
                          Go to More &rarr; Add Bank Beneficiary
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Select your Bank Name
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Enter your Branch Name and Account Number
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">Click Submit</Typography>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Bank beneficiary - happen */}
              <Accordion
                expanded={expanded === "panelBankBeneficiary-happen"}
                onChange={handleChange("panelBankBeneficiary-happen")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>
                    What happens after I add a bank beneficiary?
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography variant="body2">
                    Once you add and verify your bank account, your transaction
                    limit will increase from BDT 10,000 to BDT 400,000.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Bank beneficiary - long */}
              <Accordion
                expanded={expanded === "panelBankBeneficiary-long"}
                onChange={handleChange("panelBankBeneficiary-long")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>
                    How long does ST Pay take to verify a bank account?
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography variant="body2">
                    Once you submit your bank account details our team will
                    verify your account within 3-5 working days.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Bank beneficiary - d */}
              <Accordion
                expanded={expanded === "panelBankBeneficiary-d"}
                onChange={handleChange("panelBankBeneficiary-d")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>
                    How does ST Pay verify a user's bank account?
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography variant="body2">
                    We send a small amount to your provided bank account as part
                    of the verification process. You will then need to enter the
                    exact amount received in the designated section of the app.
                    If the system matches the input then your account will be
                    verified and you'll unlock the highest monthly transaction
                    limit available.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel12"}
                onChange={handleChange("panel12")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content12"
                  id="panel1bh-header12"
                >
                  <Typography>How to make payment Through ST Pay?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <ul>
                      <li>
                        <Typography variant="body2">
                          Click on the payment icon
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Put the merchant account number or scan qr code and
                          pay
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Insert ST Pay PIN and click on confirm
                        </Typography>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel13"}
                onChange={handleChange("panel13")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content13"
                  id="panel1bh-header13"
                >
                  <Typography>
                    Is it possible to Withdraw/Transfer money from ST Pay?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Transfer money from your ST Pay is absolutely possible.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel14"}
                onChange={handleChange("panel14")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content14"
                  id="panel1bh-header14"
                >
                  <Typography>How to Transfer money through ST Pay?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <ul>
                      <li>
                        <Typography variant="body2">
                          Click on transfer
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Click on bank and choose the bank you want to withdraw
                          money that you have added in your ST Pay account. If
                          no bank account was already added you will have to add
                          a bank account first
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Enter amount and PIN
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          Then click on confirm to initiate transfer
                        </Typography>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel15"}
                onChange={handleChange("panel15")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content15"
                  id="panel1bh-header15"
                >
                  <Typography>
                    How long does it take to Transfer money from ST Pay to
                    another bank account?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Actually,it will take a minimum of 48-72 hours to transfer
                    money from one bank to another bank account.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel17"}
                onChange={handleChange("panel17")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content17"
                  id="panel1bh-header17"
                >
                  <Typography>
                    Will I get notification after any transaction?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    All notifications are stored in the app which you will see
                    in the top right corner (Bell like icon).
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel18"}
                onChange={handleChange("panel18")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content18"
                  id="panel1bh-header18"
                >
                  <Typography>
                    How can I see my previous transaction history?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    You can view your previous transaction history from ST Pay
                    app by clicking on Transaction from the main menu
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel19"}
                onChange={handleChange("panel19")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content19"
                  id="panel1bh-header19"
                >
                  <Typography>
                    Is there any charge applicable to add money in my ST Pay?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    There will not be any charge on add-money
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel20"}
                onChange={handleChange("panel20")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content20"
                  id="panel1bh-header20"
                >
                  <Typography>
                    How to see the latest offer and promotions?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Click on offers and promotions from the main menu. Click on
                    preferred discount offer to be redirected to merchant's
                    website.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel21"}
                onChange={handleChange("panel21")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content21"
                  id="panel1bh-header21"
                >
                  <Typography>
                    How can I book flights and hotel Rooms for traveling?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    From the main menu click on the ShareTrip icon. It will
                    redirect you to the portal where you will be able to
                    directly book flights and hotels and pay from the ST Pay
                    Wallet.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel22"}
                onChange={handleChange("panel22")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content22"
                  id="panel1bh-header22"
                >
                  <Typography>
                    Is it possible in ST Pay to connect multiple Bank accounts?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Yes it is possible to connect multiple bank accounts
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel23"}
                onChange={handleChange("panel23")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content23"
                  id="panel1bh-header23"
                >
                  <Typography>
                    Can I add money from Visa/MasterCard/Amex?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Yes, you can add money using Visa, MasterCard, and Amex
                    debit or credit cards.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel24"}
                onChange={handleChange("panel24")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content24"
                  id="panel1bh-header24"
                >
                  <Typography>
                    Is it possible to send money to other MFS (Rocket,bkash) or
                    Wallet (upay, ipay)
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    No option is available at the moment
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel25"}
                onChange={handleChange("panel25")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content25"
                  id="panel1bh-header25"
                >
                  <Typography>How to buy vouchers from the App?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ul>
                    <li>
                      <Typography variant="body2">
                        Click on offers and promotions
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Click on preferred voucher that you want to buy
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Enter ST Pay PIN and click confirm
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        After that there will be option to go to home or view
                        cart
                      </Typography>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel26"}
                onChange={handleChange("panel26")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content26"
                  id="panel1bh-header26"
                >
                  <Typography>
                    How to know the latest updates from the app?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    You will always be notified each time the app updates.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              {/* <Accordion
                expanded={expanded === "panel27"}
                onChange={handleChange("panel27")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content27"
                  id="panel1bh-header27"
                >
                  <Typography>
                    Can I send money to another person's bank account?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">Yes it is possible</Typography>
                </AccordionDetails>
              </Accordion> */}
              <Accordion
                expanded={expanded === "panel28"}
                onChange={handleChange("panel28")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content28"
                  id="panel1bh-header28"
                >
                  <Typography>Can I withdraw money from an ATM?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Currently we are not giving this service to withdraw your ST
                    Pay balance from any ATM.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Nominee */}
              <h4>Nominee</h4>
              <Accordion
                expanded={expanded === "panelNominee1"}
                onChange={handleChange("panelNominee1")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee1"
                  id="panel1bh-headerNominee1"
                >
                  <Typography>What do we mean by Nominee?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    "Nominee" refers to a person nominated by a ST Pay user who
                    has the legal right to receive the remaining funds in the
                    user’s ST Pay wallet after their death.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee2"}
                onChange={handleChange("panelNominee2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee2"
                  id="panel1bh-headerNominee2"
                >
                  <Typography>
                    Why is choosing a nominee important for ST Pay User’s?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    In the event of a ST Pay user's death, their nominee will be
                    able to withdraw the remaining funds from their ST Pay
                    wallet by providing necessary information and following the
                    required process. This is why, ST Pay has introduced the
                    option for adding or changing nominee information to enable
                    a user to choose someone as their ST Pay wallet’s nominee.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee3"}
                onChange={handleChange("panelNominee3")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee3"
                  id="panel1bh-headerNominee3"
                >
                  <Typography>
                    What is Nominee Information 'Addition' and 'Update'?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    'Nominee Information Addition' refers to adding the
                    information of one or more individuals who have a National
                    ID (NID) card to your ST Pay wallet as nominees, who will be
                    eligible to receive the remaining funds in your ST Pay
                    wallet after your death if they are nominated.
                    <br />
                    <br />
                    'Nominee Information Update' refers to removing a previously
                    added nominee from your ST Pay wallet and providing the
                    information of a new person with a valid National ID card as
                    a nominee.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee4"}
                onChange={handleChange("panelNominee4")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee4"
                  id="panel1bh-headerNominee4"
                >
                  <Typography>
                    Who can add and update Nominee Information?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    All ST Pay wallet user with active ST Pay wallet can add and
                    update their Nominee Information.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee5"}
                onChange={handleChange("panelNominee5")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee5"
                  id="panel1bh-headerNominee5"
                >
                  <Typography>Who can be added as nominees?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    You add any of the following individuals with whom you have
                    a relationship as a nominee, like:
                    <div style={{ padding: "20px" }}>
                      <li>Father/Mother/Spouse/Son/Daughter/Brother/Sister</li>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee6"}
                onChange={handleChange("panelNominee6")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee6"
                  id="panel1bh-headerNominee6"
                >
                  <Typography>
                    What is required to add or update nominee information?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    To add or update nominee information, you will need your
                    active development wallet number (mobile number) and the
                    nominee's national identification card (NID card).
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee7"}
                onChange={handleChange("panelNominee7")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee7"
                  id="panel1bh-headerNominee7"
                >
                  <Typography>
                    What is the method for 'attaching' nominee information?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    To add nominee information, follow these steps:
                    <ol>
                      <li>Log in to the App</li>
                      <li>
                        Go to <strong>Nominee Information</strong> option
                      </li>
                      <li>
                        Tap <strong>Continue</strong>
                      </li>
                      <li>
                        Select <strong>Add or Update Nominee</strong>
                      </li>
                      <li>
                        Add Nominee Info:
                        <ul>
                          <li>Name</li>
                          <li>Nominee NID No</li>
                          <li>Date of Birth (DOB)</li>
                          <li>Relation with Nominee</li>
                          <li>Nominee Phone No</li>
                        </ul>
                      </li>
                      <li>
                        Tap <strong>Save</strong>
                      </li>
                    </ol>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee8"}
                onChange={handleChange("panelNominee8")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee8"
                  id="panel1bh-headerNominee8"
                >
                  <Typography>How many Nominees can be added?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    You can add up to a maximum of 2 nominees.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee9"}
                onChange={handleChange("panelNominee9")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee9"
                  id="panel1bh-headerNominee9"
                >
                  <Typography>
                    What is the process for updating nominee information?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <>
                      <div className="nominee-steps">
                        To update nominee information, follow the steps below
                        after 30 days of adding the previous nomination:
                        <ol>
                          <li>Log in to the App</li>
                          <li>
                            Go to <strong>Nominee Information</strong> option
                          </li>
                          <li>
                            Tap <strong>Continue</strong>
                          </li>
                          <li>
                            Select <strong>Add or Update Nominee</strong>
                          </li>
                          <li>
                            Update Nominee Info:
                            <ul>
                              <li>Name</li>
                              <li>Relation with Nominee</li>
                              <li>Nominee Phone No</li>
                            </ul>
                          </li>
                          <li>
                            Tap <strong>Save</strong>
                          </li>
                        </ol>
                      </div>
                    </>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee10"}
                onChange={handleChange("panelNominee10")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee10"
                  id="panel1bh-headerNominee10"
                >
                  <Typography>
                    How often can nominee information be added or updated?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    You can add or update nominee information successfully in
                    your ST Pay wallet once every 30 days.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee11"}
                onChange={handleChange("panelNominee11")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee11"
                  id="panel1bh-headerNominee11"
                >
                  <Typography>
                    Can one nominee be another person’s nominee?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    The person you’ve added as a nominee can also be added as a
                    nominee for any other user's ST Pay wallet. However, you
                    cannot add the same person again as a nominee for your own
                    wallet. <br />
                    <br />
                    For example: If there is a nominee 'A' in your Wallet, you
                    won't be able to add 'A' again as your second nominee.
                    However, your nominee 'A' can be added as a nominee in
                    someone else's* ST Pay Wallet while he or she is a nominee
                    in your Wallet.
                    <br />
                    <br />
                    * Please note that for being eligible to be your nominee,
                    the nominee’s relationship with you will be considered and
                    verified.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <h4>Customer services</h4>
              <Accordion
                expanded={expanded === "panel29"}
                onChange={handleChange("panel29")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content29"
                  id="panel1bh-header29"
                >
                  <Typography>
                    Can I add money to ST Pay using debit or credit cards?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    You can easily add money to your ST Pay wallet using
                    supported debit and credit cards.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel100"}
                onChange={handleChange("panel100")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-panel100"
                  id="panel1bh-header100"
                >
                  <Typography>
                    My card was charged but ST Pay balance not updated. What
                    should I do?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Sometimes Gateway, banks or card processors take a few
                    minutes to confirm transactions. If your card has been
                    charged, your ST Pay wallet will usually be updated
                    automatically within a short time.
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{ marginBlock: "20px 5px" }}
                  >
                    If the balance is not updated after a reasonable time our
                    support team will verify and complete the update.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel30"}
                onChange={handleChange("panel30")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content30"
                  id="panel1bh-header30"
                >
                  <Typography>
                    What is the procedure to make a complaint?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Customer can raise complaint in multiple ways:
                  </Typography>
                  <ul>
                    <li>
                      <Typography variant="body2">
                        You can directly reach us on our helpline
                        +8809617343434, available from 9 AM to 6 PM on working
                        days.
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        You can send us an email at support@stpay.net
                      </Typography>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel31"}
                onChange={handleChange("panel31")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content31"
                  id="panel1bh-header31"
                >
                  <Typography>
                    In case I change my mobile set, do I need to register again?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    No need to register again . Login from a new device you will
                    receive an OTP. After successfully verification OTP a new
                    device will be added.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <h4>Security</h4>
              <Accordion
                expanded={expanded === "panel32"}
                onChange={handleChange("panel32")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content32"
                  id="panel1bh-header32"
                >
                  <Typography>
                    Is there any PIN to put before every transaction?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Yes there is a 4-digit PIN number that is required before
                    any ST Pay transaction for ensuring your security.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel33"}
                onChange={handleChange("panel33")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content33"
                  id="panel1bh-header33"
                >
                  <Typography>How do I reset my ST Pay PIN?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Open the ST Pay app and tap the <strong>Forget Pin?</strong> link on the login screen. Follow the on-screen instructions to verify your identity using OTP and selfie verification.
                    <br/><br/>
                    Once submitted, your PIN reset request will undergo verification. The verification process may take up to 48 hours.
                    <br/><br/>
                    You will receive an SMS notification once the verification is completed.
                    <ul>
                      <li>
                        If approved: You can log in to your ST Pay account using your PIN.
                      </li>
                      <li>
                        If rejected: You will receive an SMS notification and you may try the PIN reset process again.
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel34"}
                onChange={handleChange("panel34")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content34"
                  id="panel1bh-header34"
                >
                  <Typography>
                    What can I do to change my account password?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ul>
                    <li>
                      <Typography variant="body2">
                        ST Pay App account setting
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Update password</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Put the old password
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Put the new password
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">Tap on UPDATE</Typography>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel35"}
                onChange={handleChange("panel35")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content35"
                  id="panel1bh-header35"
                >
                  <Typography>
                    What should I do if I cannot complete the payment process?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    You can simply re-login and do the process or if still you
                    fail you call our helpline.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel36"}
                onChange={handleChange("panel36")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content36"
                  id="panel1bh-header36"
                >
                  <Typography>
                    What shall I do if I do not get any Confirmation
                    Notification after any transaction?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    Whenever you face this problem please contact our helpline
                    and you can also send an email regarding this.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel37"}
                onChange={handleChange("panel37")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content37"
                  id="panel1bh-header37"
                >
                  <Typography>What is the ST Pay helpline number?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    You can reach our hotline at +8809617343434.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel38"}
                onChange={handleChange("panel38")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content38"
                  id="panel1bh-header38"
                >
                  <Typography>
                    What are the transaction limits for the Personal App?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">Sl. No</TableCell>
                            <TableCell align="left">Description</TableCell>
                            <TableCell align="left">Amount (BDT)</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>1</TableCell>
                            <TableCell>
                              Maximum balance at any point of time
                            </TableCell>
                            <TableCell>4,00,000</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>2</TableCell>
                            <TableCell>
                              Add Money through any channel per transaction
                            </TableCell>
                            <TableCell>50,000</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>3</TableCell>
                            <TableCell>Add Money Per Month</TableCell>
                            <TableCell>4,00,000</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>4</TableCell>
                            <TableCell>
                              Purchase (Personal to Business)
                            </TableCell>
                            <TableCell>No Limit</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>5</TableCell>

                            <TableCell colSpan={2}>
                              <Typography variant="h6">Send Money</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- Per transaction limit</TableCell>
                            <TableCell>50,000</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- Daily limit</TableCell>
                            <TableCell>1,00,000</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- Monthly limit</TableCell>
                            <TableCell>4,00,000</TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>6</TableCell>

                            <TableCell colSpan={2}>
                              <Typography variant="h6">
                                Transfer to Bank A/C
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- Per transaction limit</TableCell>
                            <TableCell>50,000</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- Daily limit</TableCell>
                            <TableCell>50,000</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- Monthly limit</TableCell>
                            <TableCell>4,00,000</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell colSpan={3} align="center">
                              Note: *ST Pay reserves the right to change the
                              limit structure at its discretion.
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className={classes.footer}>
        <Footer />
      </div>
    </>
  );
};

export default Faq;
